const waitForTime = `{
  "wait_for": 6000
}`;

export default waitForTime;
